import { call, put, select } from 'redux-saga/effects';
import initUA from '../initUA/initUA';
import updateWPDevice from '../../updateWPDevice/updateWPDevice';
import { selectWebphoneDevice, setWebphoneDevice } from '../../../state/webphoneDevice/webphoneDeviceSlice';
import { selectDevicePostFix } from '../../../state/configs/configsSlice';
import { setAttemptReconnect, setUAAuthorized } from '../../../state/ua/uaSlice';

export default function* initiateReconnect() {
  const devicePostFix = yield select(selectDevicePostFix);
  const wpDevice = yield select(selectWebphoneDevice);

  const updated = yield call(updateWPDevice, devicePostFix);
  if (updated.success) {
    // Create a copy of wpDevice and update the authentication_key immutably
    const updatedWpDevice = {
      ...wpDevice,
      authentication_key: updated.device.authentication_key,
    };
    yield put(setWebphoneDevice(updatedWpDevice));
    yield put(setUAAuthorized(true));
    yield put(setAttemptReconnect(false));
    yield call(initUA);
  }
}
